import { render, staticRenderFns } from "./CurrentYearConsumption.vue?vue&type=template&id=a3884c2e&scoped=true&lang=pug&"
import script from "./CurrentYearConsumption.vue?vue&type=script&lang=ts&"
export * from "./CurrentYearConsumption.vue?vue&type=script&lang=ts&"
import style0 from "./CurrentYearConsumption.vue?vue&type=style&index=0&id=a3884c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3884c2e",
  null
  
)

export default component.exports